export default __webpack_public_path__ + "static/media/scdream5.e7c0daff.woff";